// import anime from 'animejs/lib/anime.es.js';

// Helpers 

const windowHt = window.innerHeight;
const windowWd = window.innerWidth;

const scrollPercent = function (container, speed = 0, offset = 0) {
    let scrollPercent = window.pageYOffset - container.offsetTop + offset;
    if (speed) scrollPercent /= speed;
    return scrollPercent;
};


// Reveal Animation
const scrollAnim = (reveal) => {
    reveal.forEach(element => {
        let trigger = windowHt / (element.getAttribute("reveal-trigger") ? parseInt(element.getAttribute("reveal-trigger")) : 1.2);
        let elPos = element.getBoundingClientRect().top;

        if (elPos < trigger) element.classList.add('revealed');
    });
};

// Text Scroll
const fullText = (fullText) => {
    fullText.forEach((elem, i) => {
        let h1 = elem.children[0].children[0].children[0];

        if( windowWd < 991 ) {
            let perc = scrollPercent(elem, 0, windowHt) / 8;
            if( perc > 0 && perc < 200 ) {
                h1.style.backgroundPosition = `0 -${100 + perc}%`
            }
        } else {
            let perc = scrollPercent(elem, 0, windowHt) / 10;
            if( perc > 0 && perc < 200 ) {
                h1.style.backgroundPosition = `0 -${100 + perc}%`
            }
        }
    });
}

// Scroll Right

const scrollRight = (newsSection) => {
    newsSection.forEach((element) => {
        // Get the position of the current section
        let elPos = element.getBoundingClientRect().top;
        // Wrapper of the section
        let wrapper = element.children[0].children[1];

        // Articles
        let articles = wrapper.children[0].children;

        if( elPos <= 0 ) {
            // Move each child element along
            for( let i=0; i<articles.length; i++ ) {
                articles[i].style.transform = `translateX(${elPos}px)`;
            }
        } else {
            // Once the user scrolls backup reset the section back to normal
            for( let i=0; i<articles.length; i++ ) {
                articles[i].style.transform = `translateX(0px)`;
            }
        }
    });
}

// Set the height of the news section depedant on how many articles there are
const setNewsHeight = (newsSection) => {
    newsSection.forEach((element) => {
        if( document.body.clientWidth < 992 ) {
            element.style.height = element.children[0].children[1].scrollWidth + 710 + 'px';
        } else {
            element.style.height = element.children[0].children[1].scrollWidth + 'px';
        }
    });
}

// Anims Init

window.addEventListener("DOMContentLoaded", () => {
    scrollAnim(document.querySelectorAll(".reveal"));
    fullText(document.querySelectorAll('.full-screen-text'));
    scrollRight(document.querySelectorAll(".news"));
    setNewsHeight(document.querySelectorAll(".news"));

    window.addEventListener('scroll', () => {
        scrollAnim(document.querySelectorAll(".reveal"));
        fullText(document.querySelectorAll('.full-screen-text'));
        scrollRight(document.querySelectorAll(".news"));
    }, {passive:true});
});
